import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SEO_DATA = {
  en: {
    title: "Bricksup - LEGO Mosaic Converter",
    description:
      "Convert images to LEGO brick mosaics with step-by-step building instructions",
    keywords:
      "LEGO, mosaic, pixel art, brick converter, building instructions, LEGO creator, brick visualization",
    ogLocale: "en_US",
  },
  "zh-CN": {
    title: "Bricksup - 乐高积木马赛克转换器",
    description: "将图像转换为乐高积木马赛克，并提供分步搭建说明",
    keywords: "乐高, 马赛克, 像素艺术, 积木转换器, 搭建说明",
    ogLocale: "zh_CN",
  },
  "zh-TW": {
    title: "Bricksup - 樂高積木馬賽克轉換器",
    description: "將圖像轉換為樂高積木馬賽克，並提供分步搭建說明",
    keywords: "樂高, 馬賽克, 像素藝術, 積木轉換器, 搭建說明",
    ogLocale: "zh_TW",
  },
  ja: {
    title: "Bricksup - レゴモザイクコンバーター",
    description:
      "画像をレゴブロックモザイクに変換し、ステップバイステップの組み立て説明を提供",
    keywords: "レゴ, モザイク, ピクセルアート, ブロックコンバーター, 組み立て説明",
    ogLocale: "ja_JP",
  },
  ko: {
    title: "Bricksup - 레고 모자이크 변환기",
    description:
      "이미지를 레고 블록 모자이크로 변환하고 단계별 조립 설명을 제공",
    keywords: "레고, 모자이크, 픽셀 아트, 블록 변환기, 조립 설명",
    ogLocale: "ko_KR",
  },
};

export const SEOMetaTags: React.FC = () => {
  const { i18n } = useTranslation();
  const seo =
    SEO_DATA[i18n.language as keyof typeof SEO_DATA] || SEO_DATA.en;

  useEffect(() => {
    // Update document title
    document.title = seo.title;

    // Update meta description
    updateMeta("description", seo.description);
    updateMeta("keywords", seo.keywords);

    // Update Open Graph
    updateMeta("og:locale", seo.ogLocale);
    updateMeta("og:title", seo.title);
    updateMeta("og:description", seo.description);

    // Update Twitter Card
    updateMeta("twitter:title", seo.title);
    updateMeta("twitter:description", seo.description);

    // Update HTML lang and dir
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = "ltr";

    // Update canonical URL with language
    const canonical = document.querySelector(
      'link[rel="canonical"]'
    ) as HTMLLinkElement;
    if (canonical) {
      canonical.href = `https://bricksup.com/${
        i18n.language !== "en" ? i18n.language : ""
      }`;
    }
  }, [i18n.language, seo]);

  return null;
};

function updateMeta(name: string, content: string) {
  let meta =
    document.querySelector(`meta[property="${name}"]`) ||
    document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    (meta as HTMLMetaElement).name = name.startsWith("og:")
      ? "property"
      : "name";
    meta.setAttribute(name.startsWith("og:") ? "property" : "name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}
